import { jsPDF } from "jspdf";

const generatePurchaseInvoice = (data) => {
  console.log("working");
  GeneratePurchase(data?.skus, data?.VendorName, data);

  function GeneratePurchase(
    items = [],
    customer = {},
    mainitem = {},
    adminLoggedIn = {}
  ) {
    const {
      InvoiceNo,
      InvoiceDate,
      ProductName,
      HSNCode,
      Purity,
      Qty,
      GrossWt,
      StoneWt,
      NetWt,
      StoneAmount,
      MakingPerGram,
      TotalAmount,
      UrdPurchaseAmt,
      Payments,
      PaymentMode,
      GST,
    } = mainitem;

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const pageHeight = doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.getWidth();

    const boxTopMargin = 42.5 + 10;
    const boxPadding = 5; // Padding on both sides
    const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
    const boxHeight = 28;
    doc.setFontSize(16);
    doc.text("Purchase", 90, 50);
    doc.line(0, 54.5, 210, 54.5); // Draw a horizontal line

    const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

    const totalgross = urdPurchasePositive - UrdPurchaseAmt;

    const cgst = +(GST || 0) / 2;
    const sgst = +(GST || 0) / 2;

    // const sGstFx = sGst.toFixed(2)
    const totalAmountNumber = Number(TotalAmount);
    const GSTNumber = Number(GST);

    // doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

    // Set up customer details
    const address = `${customer?.CurrAddStreet || "NA"}, ${
      customer?.CurrAddTown || ""
    }, ${customer?.CurrAddPincode || ""}`;
    // Billing information
    doc.setLineWidth(0.3);
    // doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height
    doc.setFont("Helvetica", "Bold");
    doc.setFontSize(16);
    // doc.text("GOLD SALE", boxPadding + boxWidth / 2 - 20, boxTopMargin - 3);
    doc.setFontSize(8);

    let currAddress = "";
    if (mainitem?.Customer?.CurrAddStreet) {
      currAddress += mainitem?.Customer?.CurrAddStreet + ", ";
    }
    if (mainitem?.Customer?.CurrAddTown) {
      currAddress += mainitem?.Customer?.CurrAddTown + ", ";
    }
    if (mainitem?.Customer?.CurrAddState) {
      currAddress += mainitem?.Customer?.CurrAddState + ", ";
    }
    if (mainitem?.Customer?.CurrAddPincode) {
      currAddress += mainitem?.Customer?.CurrAddPincode + " ";
    }

    const billingDetails = [
      `NAME                      :   ${customer?.label}`,
      `Invoice No               : ${mainitem?.invoiceNumber}`,
    ];

    let startY = boxTopMargin + 8;
    billingDetails.forEach((detail) => {
      doc.text(detail, boxPadding + 2, startY);
      startY += 6;
    });

    // Second column data
    const secondColumn = [
      { label: "Date               ", value: `${mainitem?.invoiceDate}` },
      { label: "Lot NO        ", value: `${mainitem?.LotNumber}` },
    ];

    // Define second column starting position
    const secondColumnStartX = boxPadding + 100; // Adjust as needed
    let secondColumnStartY = boxTopMargin + 8; // Align with first column

    // Print second column data
    secondColumn.forEach(({ label, value }) => {
      doc.text(
        `${label}: ${value}`,
        secondColumnStartX + 50,
        secondColumnStartY
      );
      secondColumnStartY += 6; // Move to the next line
    });

    const rowHeight = 10; // Height per item row
    let tableStartY = startY; // Start of the table

    const columnWidths = {
      "Sr.No": 14.18,
      SKU: 35,
      Testing: 25.18,
       "Total Wt": 28.18,
      // "Pouch Wt": 16.18,
      "QTY": 16.18,
      "Packing Wt": 21.18,
      "ST Pcs": 21.18,
      "ST Wt": 21.18,
       "Net Wt": 27.18,
    };

    const columnArray = [
      "Sr.No",
      "SKU",
      "Testing",
       "Total Wt",
      // "Pouch Wt",
      "QTY",
      "Packing Wt",
      "ST Pcs",
      "ST Wt",
      "Net Wt",
    ];

    // Function to render table headers
    function renderHeaders(currentY) {
      let startX = boxPadding; // Starting X position for table
      columnArray.forEach((col) => {
        doc.text(col, startX + 2, currentY + 2);
        startX += columnWidths[col];

        // doc.line(5, 100, 205, 100); //horizontal line after table headers
      });

      // Draw vertical lines for headers
      startX = boxPadding;
      columnArray.forEach((col, index) => {
        // if(index == columnArray.length - 1){
        //   return
        // }
        doc.line(startX, currentY - 4, startX, currentY + rowHeight ); // Vertical line
        startX += columnWidths[col];
      });

      // Ensure the last vertical line extends fully
      // doc.line(startX + 12.5, currentY - 4, startX + 12.5, currentY + rowHeight + 30);
    }

    // Ensure headers on the first page
    renderHeaders(tableStartY);

    tableStartY += 7; // Adjust for the first header row

    doc.line(5, 68.5, 206, 68.5);
    doc.line(5, 76.5, 206, 76.5);
    // Draw table and handle borders
    let rowStartY = tableStartY;

    let tableHeightUsed = 0;
    doc.setFont("Helvetica", "Normal");
    doc.setFontSize(8);

    let totalTesting = 0;
    let totalTotalWt = 0;
    let totalPackingWeight = 0;
    let totalQty = 0;
    let totalStoneWt = 0;
    let totalStonePieces = 0;
    let totalNetWt = 0;
    let totalClipWt = 0;
    let totalPackingWt = 0;
    items?.forEach((item, index) => {
      totalTesting += +(item?.Testing || 0);
      // totalTotalWt += +(item?.TotalWt || 0);
      totalTotalWt += +(item?.TotalWt || 0);
      totalQty += +(item?.Qty || 0);
      totalPackingWeight += +(item?.PackingWeight || 0);
      totalStonePieces += +(item?.StonePieces || 0);
      totalStoneWt += +(item?.StoneWt || 0);
      totalNetWt += +(item?.NetWt || 0);
      // totalPackingWt += +(item?.PackingWeight || 0);

      if (rowStartY + rowHeight > pageHeight - 5) {
        // Check space at the bottom
        // Draw table border for the previous page
        const contentHeight = rowStartY - tableStartY;
        // doc.rect(boxPadding, tableStartY, boxWidth, contentHeight);
        // Add a horizontal line before adding a new page
        // doc.line(5, rowStartY, 205, rowStartY);
        tableHeightUsed += rowStartY - tableStartY;

        doc.addPage(); // Add a new page
        rowStartY = 3; // Reset Y position for the new page
        tableStartY = rowStartY; // Update table start Y for the new page

        // Draw a new table border for the new page
        renderHeaders(rowStartY - 2);
        rowStartY += 7; // Position after headers
        // doc.line(5, 10, 205, 10); //horizontal line after table headers
      }
      console.log(item);

      let startX = boxPadding + 2; // Reset startX for each new row
      const itemData = [
        index + 1,
        `${item?.StockKeepingUnit?.label}`?.substring(
          0,
          30
        ) ,
        (+(item?.Testing || 0))?.toFixed(4),
        (+(item?.TotalWt || 0))?.toFixed(4),
        (+(item?.Qty || 0)),
        (+(item?.PackingWeight || 0))?.toFixed(4),
        +(item?.StonePieces || 0),
        (+(item?.StoneWt || 0))?.toFixed(4),
        (+(item?.NetWt || 0))?.toFixed(4),       
      ];

      itemData?.forEach((data, colIndex) => {
        doc.text(`${data}`, startX, rowStartY + 8);
        startX += columnWidths[columnArray[colIndex]];
      });

      doc.setFont("Helvetica", "Normal");
      doc.setFontSize(8);
      // Draw vertical lines for table rows
      startX = boxPadding;
      columnArray.forEach((col, colIndex) => {
        doc.line(startX, rowStartY, startX, rowStartY + rowHeight + 13); // Vertical line for each column
        
        startX += columnWidths[col];
        if (colIndex === columnArray.length - 1) {
          doc.line(
            startX - 8.5,
            rowStartY - 11,
            startX - 8.5,
            rowStartY + rowHeight + 13
          ); // Last vertical line
        }
      });



      rowStartY += rowHeight; // Move to the next row
    });

    doc.line(5,rowStartY + rowHeight - 5, 206, rowStartY + rowHeight - 5) //total above line
    doc.line(5,rowStartY + rowHeight + 3, 206, rowStartY + rowHeight + 3) // total below line

    doc.setFont("Helvetica", "normal");
    let startXX = boxPadding + 2;
    const totalsData = [
      "", // Empty for index column
      "", // "Total" label in ProductName column
      (+(totalTesting || 0))?.toFixed(4),
      (+(totalTotalWt || 0))?.toFixed(4),
      `${+(totalQty || 0)}`,
      // (+(totalPouchWt || 0))?.toFixed(3),
      (+(totalPackingWeight || 0))?.toFixed(4),
      `${+(totalStonePieces || 0)}`,
      `${(+(totalStoneWt || 0))?.toFixed(4)}`,
      `${(+(totalNetWt || 0))?.toFixed(4)}`,

     
      
    
    ];

  


    totalsData.forEach((data, index) => {
      doc.text(`${data}`, startXX, rowStartY + 10);
      startXX += columnWidths[columnArray[index]]; // Move to the next column
    });

    // Store the final table height used on the last page
    tableHeightUsed += rowStartY - tableStartY;

    // Additional contents (for example, terms, conditions, signatures, etc.)
    let contentStartY = rowStartY + 10; // Start below the table

    // Draw final table border for the last page
    let finalContentHeight = rowStartY - tableStartY;

    if (contentStartY + 20 > pageHeight) {
      // Draw final table border for the last page
      finalContentHeight = rowStartY - tableStartY + 4;
    }

    if (contentStartY + 20 > pageHeight) {
      doc.addPage(); // Add a new page
      contentStartY = 10; // Reset Y on new page
    }

    //  Add horizontal line after the last row of the table
    // if (rowStartY <= pageHeight - 5) {
    //   // Ensure horizontal line is added at the end of the table
    //   doc.line(5, rowStartY, 205, rowStartY);
    // }

    function checkAndAddPage(currentY, sectionHeight) {
      if (currentY + sectionHeight > pageHeight - 20) {
        // Adjust to prevent cutoff
        doc.addPage();
        return 10; // Reset Y position for new page
      }
      return currentY;
    }

    // Now create a second section with two columns: "Cash" and its amount
    const cashSectionX = 5; // Starting X position for the cash section
    let summaryStartY = rowStartY; // Add spacing after the first table
    summaryStartY = checkAndAddPage(summaryStartY, 80); // Ensure it fits in the page
    let cashStartY = summaryStartY; // Place cash details below summary
    cashStartY = checkAndAddPage(cashStartY, 20); // Ensure cash details fit
    const cashCellWidth = 50; // Width of each column for the cash table

    // Draw the "Cash" label cell
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");

    const leftColumn = [
      { label: "Gross Amount", value: `${totalgross.toFixed(3)}` },
      { label: "CGST 1.5%", value: `${Number(cgst).toFixed(2)}` },
      { label: "SGST 1.5%", value: `${Number(sgst).toFixed(2)}` },
      { label: "IGST 3%", value: `${GSTNumber.toFixed(2)}` },
      // { label: 'Courier', value: '' },
      { label: "Purchase Amount (-)", value: `${UrdPurchaseAmt}` },
      { label: "RO/Discount (-)", value: "" },
      { label: "Net Amount", value: `${(totalgross + GSTNumber).toFixed(2)}` },
    ];

    console.log(adminLoggedIn);
    // Dummy values for the right column
    const rightColumnValues = [
      `${mainitem?.TotalNetAmount}`,
      `${
        adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
          ? Number(cgst).toFixed(2)
          : ""
      }`,
      `${
        adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
          ? Number(sgst).toFixed(2)
          : ""
      }`,
      `${
        adminLoggedIn?.State != mainitem?.Customer?.CurrAddState
          ? (+(GST || 0)).toFixed(2)
          : ""
      }`,
      // `${(+(mainitem?.CourierCharge || 0))?.toFixed(3)}`,
      `${(
        +(mainitem?.TotalNetAmount || 0) +
        +(mainitem?.GST || 0) +
        +(mainitem?.TDS || 0) +
        +(mainitem?.CourierCharge || 0)
      )?.toFixed(3)}`,
      `${mainitem?.Offer || ""}`,
      `${(
        +(mainitem?.TotalNetAmount || 0) +
        +(mainitem?.GST || 0) +
        +(mainitem?.TDS || 0) +
        +(mainitem?.CourierCharge || 0) -
        +(mainitem?.Offer || 0)
      )?.toFixed(3)}`,
    ];

    // Set table starting position and dimensions
    const startX4 = 135; // Starting X position for the table
    const startY4 = 130; // Starting Y position for the table
    const tableWidth4 = 70; // Table width
    const tableHeight4 = 80; // Table height (adjust based on number of rows)
    const cellHeight4 = 10; // Height for each cell row
    const verticalLineX = startX4 + tableWidth4 / 2; // X position for the center vertical line

    // SUMMARY TABLE
    // doc.rect(startX4, summaryStartY, tableWidth4, tableHeight4);
    // doc.line(
    //   verticalLineX,
    //   summaryStartY,
    //   verticalLineX,
    //   summaryStartY + tableHeight4
    // );
    let ypos;

    // leftColumn.forEach((row, index) => {
    //   ypos = summaryStartY + (index + 1) * cellHeight4 - 3;
    //   doc.text(`${row.label}`, startX4 + 2, ypos);
    //   doc.text(`${rightColumnValues[index]}`, verticalLineX + 2, ypos);
    //   doc.line(startX4, ypos + 3, startX4 + tableWidth4, ypos + 3);
    // });

    // Determine the starting position below the main dynamic table
    let newTableStartY = rowStartY + 10; // Ensure proper spacing below dynamic table
    doc.setFont("helvetica", "normal");

    // New Table (Above Cash & RTGS)
    // doc.rect(cashSectionX, newTableStartY, cashCellWidth * 2, 10); // Full row width
    // doc.line(
    //   cashSectionX + cashCellWidth,
    //   newTableStartY,
    //   cashSectionX + cashCellWidth,
    //   newTableStartY + 10
    // ); // Middle vertical line

    // Sample data row
    let newTableRowStartY = newTableStartY - 10;
    // doc.rect(cashSectionX, ypos - 66, cashCellWidth * 2, 10); // Row border
    // doc.line(
    //   cashSectionX + cashCellWidth,
    //   newTableRowStartY,
    //   cashSectionX + cashCellWidth,
    //   newTableRowStartY + 10
    // ); // Middle vertical

    // doc.text("ITEM", cashSectionX + 5, ypos - 62);
    // doc.text("GROSS WT", cashSectionX + cashCellWidth / 2 + 5, ypos - 62);
    // doc.text("NET WT", cashSectionX + cashCellWidth + 5, ypos - 62);
    // doc.text(
    //   "AMOUNT",
    //   cashSectionX + cashCellWidth + cashCellWidth / 2,
    //   ypos - 62
    // );

    // doc.text("Old Gold", cashSectionX + 5, ypos - 53);
    // doc.text("22.700", cashSectionX + cashCellWidth / 2 + 5, ypos - 53);
    // doc.text("20.66", cashSectionX + cashCellWidth + 5, ypos - 53);
    // doc.text(
    //   "105000",
    //   cashSectionX + cashCellWidth + cashCellWidth / 2,
    //   ypos - 53
    // );

    // Update starting position for Cash Table
    let cashStartY2 = newTableRowStartY + 25; // Move below the new table

    // CASH DETAILS TABLE

    // doc.text(
    //   "Cash",
    //   cashSectionX + cashCellWidth / 2 - doc.getTextWidth("Cash") / 2,
    //   ypos - 35
    // );
    // doc.rect(cashSectionX, ypos - 40, cashCellWidth, 10);
    // doc.rect(cashSectionX + cashCellWidth, ypos - 40, cashCellWidth, 10);

    const pdfData = doc.output("datauristring");
    const newWindow = window.open();
    newWindow.document.write(
      `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
    );
  }
};

export function GeneratePurchase(
  items = [],
  customer = {},
  mainitem = {},
  adminLoggedIn = {}
) {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();

  const boxTopMargin = 42.5 + 10;
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 28;
  doc.setFontSize(16);
  doc.text("Purchase", 90, 50);
  doc.line(0, 54.5, 210, 54.5); // Draw a horizontal line

  const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

  const totalgross = urdPurchasePositive - UrdPurchaseAmt;

  const cgst = +(GST || 0) / 2;
  const sgst = +(GST || 0) / 2;

  // const sGstFx = sGst.toFixed(2)
  const totalAmountNumber = Number(TotalAmount);
  const GSTNumber = Number(GST);

  // doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

  // Set up customer details
  const address = `${customer?.CurrAddStreet || "NA"}, ${
    customer?.CurrAddTown || ""
  }, ${customer?.CurrAddPincode || ""}`;
  // Billing information
  doc.setLineWidth(0.3);
  // doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height
  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(16);
  // doc.text("GOLD SALE", boxPadding + boxWidth / 2 - 20, boxTopMargin - 3);
  doc.setFontSize(8);

  let currAddress = "";
  if (mainitem?.Customer?.CurrAddStreet) {
    currAddress += mainitem?.Customer?.CurrAddStreet + ", ";
  }
  if (mainitem?.Customer?.CurrAddTown) {
    currAddress += mainitem?.Customer?.CurrAddTown + ", ";
  }
  if (mainitem?.Customer?.CurrAddState) {
    currAddress += mainitem?.Customer?.CurrAddState + ", ";
  }
  if (mainitem?.Customer?.CurrAddPincode) {
    currAddress += mainitem?.Customer?.CurrAddPincode + " ";
  }

  const billingDetails = [
    `NAME                      :   ${customer?.label}`,
    `Invoice No               : ${mainitem?.invoiceNumber}`,
  ];

  let startY = boxTopMargin + 8;
  billingDetails.forEach((detail) => {
    doc.text(detail, boxPadding + 2, startY);
    startY += 6;
  });

  // Second column data
  const secondColumn = [
    { label: "Date               ", value: `${mainitem?.invoiceDate}` },
    { label: "Lot NO        ", value: `${mainitem?.LotNumber}` },
  ];

  // Define second column starting position
  const secondColumnStartX = boxPadding + 100; // Adjust as needed
  let secondColumnStartY = boxTopMargin + 8; // Align with first column

  // Print second column data
  secondColumn.forEach(({ label, value }) => {
    doc.text(
      `${label}: ${value}`,
      secondColumnStartX + 50,
      secondColumnStartY
    );
    secondColumnStartY += 6; // Move to the next line
  });

  const rowHeight = 10; // Height per item row
  let tableStartY = startY; // Start of the table

  const columnWidths = {
    "Sr.No": 14.18,
    SKU: 35,
    Testing: 25.18,
     "Total Wt": 28.18,
    // "Pouch Wt": 16.18,
    "QTY": 16.18,
    "Packing Wt": 21.18,
    "ST Pcs": 21.18,
    "ST Wt": 21.18,
     "Net Wt": 27.18,
  };

  const columnArray = [
    "Sr.No",
    "SKU",
    "Testing",
     "Total Wt",
    // "Pouch Wt",
    "QTY",
    "Packing Wt",
    "ST Pcs",
    "ST Wt",
    "Net Wt",
  ];

  // Function to render table headers
  function renderHeaders(currentY) {
    let startX = boxPadding; // Starting X position for table
    columnArray.forEach((col) => {
      doc.text(col, startX + 2, currentY + 2);
      startX += columnWidths[col];

      // doc.line(5, 100, 205, 100); //horizontal line after table headers
    });

    // Draw vertical lines for headers
    startX = boxPadding;
    columnArray.forEach((col, index) => {
      // if(index == columnArray.length - 1){
      //   return
      // }
      doc.line(startX, currentY - 4, startX, currentY + rowHeight ); // Vertical line
      startX += columnWidths[col];
    });

    // Ensure the last vertical line extends fully
    // doc.line(startX + 12.5, currentY - 4, startX + 12.5, currentY + rowHeight + 30);
  }

  // Ensure headers on the first page
  renderHeaders(tableStartY);

  tableStartY += 7; // Adjust for the first header row

  doc.line(5, 68.5, 206, 68.5);
  doc.line(5, 76.5, 206, 76.5);
  // Draw table and handle borders
  let rowStartY = tableStartY;

  let tableHeightUsed = 0;
  doc.setFont("Helvetica", "Normal");
  doc.setFontSize(8);

  let totalTesting = 0;
  let totalTotalWt = 0;
  let totalPackingWeight = 0;
  let totalQty = 0;
  let totalStoneWt = 0;
  let totalStonePieces = 0;
  let totalNetWt = 0;
  let totalClipWt = 0;
  let totalPackingWt = 0;
  items?.forEach((item, index) => {
    totalTesting += +(item?.Testing || 0);
    // totalTotalWt += +(item?.TotalWt || 0);
    totalTotalWt += +(item?.TotalWt || 0);
    totalQty += +(item?.Qty || 0);
    totalPackingWeight += +(item?.PackingWeight || 0);
    totalStonePieces += +(item?.StonePieces || 0);
    totalStoneWt += +(item?.StoneWt || 0);
    totalNetWt += +(item?.NetWt || 0);
    // totalPackingWt += +(item?.PackingWeight || 0);

    if (rowStartY + rowHeight > pageHeight - 5) {
      // Check space at the bottom
      // Draw table border for the previous page
      const contentHeight = rowStartY - tableStartY;
      // doc.rect(boxPadding, tableStartY, boxWidth, contentHeight);
      // Add a horizontal line before adding a new page
      // doc.line(5, rowStartY, 205, rowStartY);
      tableHeightUsed += rowStartY - tableStartY;

      doc.addPage(); // Add a new page
      rowStartY = 3; // Reset Y position for the new page
      tableStartY = rowStartY; // Update table start Y for the new page

      // Draw a new table border for the new page
      renderHeaders(rowStartY - 2);
      rowStartY += 7; // Position after headers
      // doc.line(5, 10, 205, 10); //horizontal line after table headers
    }
    console.log(item);

    let startX = boxPadding + 2; // Reset startX for each new row
    const itemData = [
      index + 1,
      // `${item?.StockKeepingUnit?.label}`?.substring(
      //   0,
      //   30
      // ) ,
      `${item?.StockKeepingUnit?.label ?? ""}`.substring(0, 30),

      (+(item?.Testing || 0))?.toFixed(4),
      (+(item?.TotalWt || 0))?.toFixed(4),
      (+(item?.Qty || 0)),
      (+(item?.PackingWeight || 0))?.toFixed(4),
      +(item?.StonePieces || 0),
      (+(item?.StoneWt || 0))?.toFixed(4),
      (+(item?.NetWt || 0))?.toFixed(4),       
    ];

    itemData?.forEach((data, colIndex) => {
      doc.text(`${data}`, startX, rowStartY + 8);
      startX += columnWidths[columnArray[colIndex]];
    });

    doc.setFont("Helvetica", "Normal");
    doc.setFontSize(8);
    // Draw vertical lines for table rows
    startX = boxPadding;
    columnArray.forEach((col, colIndex) => {
      doc.line(startX, rowStartY, startX, rowStartY + rowHeight + 13); // Vertical line for each column
      
      startX += columnWidths[col];
      if (colIndex === columnArray.length - 1) {
        doc.line(
          startX - 8.5,
          rowStartY - 11,
          startX - 8.5,
          rowStartY + rowHeight + 13
        ); // Last vertical line
      }
    });



    rowStartY += rowHeight; // Move to the next row
  });

  doc.line(5,rowStartY + rowHeight - 5, 206, rowStartY + rowHeight - 5) //total above line
  doc.line(5,rowStartY + rowHeight + 3, 206, rowStartY + rowHeight + 3) // total below line

  doc.setFont("Helvetica", "normal");
  let startXX = boxPadding + 2;
  const totalsData = [
    "", // Empty for index column
    "", // "Total" label in ProductName column
    (+(totalTesting || 0))?.toFixed(4),
    (+(totalTotalWt || 0))?.toFixed(4),
    `${+(totalQty || 0)}`,
    // (+(totalPouchWt || 0))?.toFixed(3),
    (+(totalPackingWeight || 0))?.toFixed(4),
    `${+(totalStonePieces || 0)}`,
    `${(+(totalStoneWt || 0))?.toFixed(4)}`,
    `${(+(totalNetWt || 0))?.toFixed(4)}`,

   
    
  
  ];




  totalsData.forEach((data, index) => {
    doc.text(`${data}`, startXX, rowStartY + 10);
    startXX += columnWidths[columnArray[index]]; // Move to the next column
  });

  // Store the final table height used on the last page
  tableHeightUsed += rowStartY - tableStartY;

  // Additional contents (for example, terms, conditions, signatures, etc.)
  let contentStartY = rowStartY + 10; // Start below the table

  // Draw final table border for the last page
  let finalContentHeight = rowStartY - tableStartY;

  if (contentStartY + 20 > pageHeight) {
    // Draw final table border for the last page
    finalContentHeight = rowStartY - tableStartY + 4;
  }

  if (contentStartY + 20 > pageHeight) {
    doc.addPage(); // Add a new page
    contentStartY = 10; // Reset Y on new page
  }

  //  Add horizontal line after the last row of the table
  // if (rowStartY <= pageHeight - 5) {
  //   // Ensure horizontal line is added at the end of the table
  //   doc.line(5, rowStartY, 205, rowStartY);
  // }

  function checkAndAddPage(currentY, sectionHeight) {
    if (currentY + sectionHeight > pageHeight - 20) {
      // Adjust to prevent cutoff
      doc.addPage();
      return 10; // Reset Y position for new page
    }
    return currentY;
  }

  // Now create a second section with two columns: "Cash" and its amount
  const cashSectionX = 5; // Starting X position for the cash section
  let summaryStartY = rowStartY; // Add spacing after the first table
  summaryStartY = checkAndAddPage(summaryStartY, 80); // Ensure it fits in the page
  let cashStartY = summaryStartY; // Place cash details below summary
  cashStartY = checkAndAddPage(cashStartY, 20); // Ensure cash details fit
  const cashCellWidth = 50; // Width of each column for the cash table

  // Draw the "Cash" label cell
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");

  const leftColumn = [
    { label: "Gross Amount", value: `${totalgross.toFixed(3)}` },
    { label: "CGST 1.5%", value: `${Number(cgst).toFixed(2)}` },
    { label: "SGST 1.5%", value: `${Number(sgst).toFixed(2)}` },
    { label: "IGST 3%", value: `${GSTNumber.toFixed(2)}` },
    // { label: 'Courier', value: '' },
    { label: "Purchase Amount (-)", value: `${UrdPurchaseAmt}` },
    { label: "RO/Discount (-)", value: "" },
    { label: "Net Amount", value: `${(totalgross + GSTNumber).toFixed(2)}` },
  ];

  console.log(adminLoggedIn);
  // Dummy values for the right column
  const rightColumnValues = [
    `${mainitem?.TotalNetAmount}`,
    `${
      adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
        ? Number(cgst).toFixed(2)
        : ""
    }`,
    `${
      adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
        ? Number(sgst).toFixed(2)
        : ""
    }`,
    `${
      adminLoggedIn?.State != mainitem?.Customer?.CurrAddState
        ? (+(GST || 0)).toFixed(2)
        : ""
    }`,
    // `${(+(mainitem?.CourierCharge || 0))?.toFixed(3)}`,
    `${(
      +(mainitem?.TotalNetAmount || 0) +
      +(mainitem?.GST || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0)
    )?.toFixed(3)}`,
    `${mainitem?.Offer || ""}`,
    `${(
      +(mainitem?.TotalNetAmount || 0) +
      +(mainitem?.GST || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0) -
      +(mainitem?.Offer || 0)
    )?.toFixed(3)}`,
  ];

  // Set table starting position and dimensions
  const startX4 = 135; // Starting X position for the table
  const startY4 = 130; // Starting Y position for the table
  const tableWidth4 = 70; // Table width
  const tableHeight4 = 80; // Table height (adjust based on number of rows)
  const cellHeight4 = 10; // Height for each cell row
  const verticalLineX = startX4 + tableWidth4 / 2; // X position for the center vertical line

  // SUMMARY TABLE
  // doc.rect(startX4, summaryStartY, tableWidth4, tableHeight4);
  // doc.line(
  //   verticalLineX,
  //   summaryStartY,
  //   verticalLineX,
  //   summaryStartY + tableHeight4
  // );
  let ypos;

  // leftColumn.forEach((row, index) => {
  //   ypos = summaryStartY + (index + 1) * cellHeight4 - 3;
  //   doc.text(`${row.label}`, startX4 + 2, ypos);
  //   doc.text(`${rightColumnValues[index]}`, verticalLineX + 2, ypos);
  //   doc.line(startX4, ypos + 3, startX4 + tableWidth4, ypos + 3);
  // });

  // Determine the starting position below the main dynamic table
  let newTableStartY = rowStartY + 10; // Ensure proper spacing below dynamic table
  doc.setFont("helvetica", "normal");

  // New Table (Above Cash & RTGS)
  // doc.rect(cashSectionX, newTableStartY, cashCellWidth * 2, 10); // Full row width
  // doc.line(
  //   cashSectionX + cashCellWidth,
  //   newTableStartY,
  //   cashSectionX + cashCellWidth,
  //   newTableStartY + 10
  // ); // Middle vertical line

  // Sample data row
  let newTableRowStartY = newTableStartY - 10;
  // doc.rect(cashSectionX, ypos - 66, cashCellWidth * 2, 10); // Row border
  // doc.line(
  //   cashSectionX + cashCellWidth,
  //   newTableRowStartY,
  //   cashSectionX + cashCellWidth,
  //   newTableRowStartY + 10
  // ); // Middle vertical

  // doc.text("ITEM", cashSectionX + 5, ypos - 62);
  // doc.text("GROSS WT", cashSectionX + cashCellWidth / 2 + 5, ypos - 62);
  // doc.text("NET WT", cashSectionX + cashCellWidth + 5, ypos - 62);
  // doc.text(
  //   "AMOUNT",
  //   cashSectionX + cashCellWidth + cashCellWidth / 2,
  //   ypos - 62
  // );

  // doc.text("Old Gold", cashSectionX + 5, ypos - 53);
  // doc.text("22.700", cashSectionX + cashCellWidth / 2 + 5, ypos - 53);
  // doc.text("20.66", cashSectionX + cashCellWidth + 5, ypos - 53);
  // doc.text(
  //   "105000",
  //   cashSectionX + cashCellWidth + cashCellWidth / 2,
  //   ypos - 53
  // );

  // Update starting position for Cash Table
  let cashStartY2 = newTableRowStartY + 25; // Move below the new table

  // CASH DETAILS TABLE

  // doc.text(
  //   "Cash",
  //   cashSectionX + cashCellWidth / 2 - doc.getTextWidth("Cash") / 2,
  //   ypos - 35
  // );
  // doc.rect(cashSectionX, ypos - 40, cashCellWidth, 10);
  // doc.rect(cashSectionX + cashCellWidth, ypos - 40, cashCellWidth, 10);

  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
}


// function generatePurchaseInvoice(items, customer, mainitem, adminLoggedIn) {
//   const {
//     InvoiceNo,
//     InvoiceDate,
//     ProductName,
//     HSNCode,
//     Purity,
//     Qty,
//     GrossWt,
//     StoneWt,
//     NetWt,
//     StoneAmount,
//     MakingPerGram,
//     TotalAmount,
//     UrdPurchaseAmt,
//     Payments,
//     PaymentMode,
//     GST,
//   } = mainitem;

//   const doc = new jsPDF({
//     orientation: "portrait",
//     unit: "mm",
//     format: "a4",
//   });

//   const pageHeight = doc.internal.pageSize.getHeight();
//   const pageWidth = doc.internal.pageSize.getWidth();

//   const boxTopMargin = 42.5 + 10;
//   const boxPadding = 5; // Padding on both sides
//   const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
//   const boxHeight = 28;
//   doc.setFontSize(16);
//   doc.text("Purchase", 90, 50);
//   doc.line(0, 54.5, 210, 54.5); // Draw a horizontal line

//   const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

//   const totalgross = urdPurchasePositive - UrdPurchaseAmt;

//   const cgst = +(GST || 0) / 2;
//   const sgst = +(GST || 0) / 2;

//   // const sGstFx = sGst.toFixed(2)
//   const totalAmountNumber = Number(TotalAmount);
//   const GSTNumber = Number(GST);

//   // doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

//   // Set up customer details
//   const address = `${customer?.CurrAddStreet || "NA"}, ${
//     customer?.CurrAddTown || ""
//   }, ${customer?.CurrAddPincode || ""}`;
//   // Billing information
//   doc.setLineWidth(0.3);
//   // doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height
//   doc.setFont("Helvetica", "Bold");
//   doc.setFontSize(16);
//   // doc.text("GOLD SALE", boxPadding + boxWidth / 2 - 20, boxTopMargin - 3);
//   doc.setFontSize(8);

//   let currAddress = "";
//   if (mainitem?.Customer?.CurrAddStreet) {
//     currAddress += mainitem?.Customer?.CurrAddStreet + ", ";
//   }
//   if (mainitem?.Customer?.CurrAddTown) {
//     currAddress += mainitem?.Customer?.CurrAddTown + ", ";
//   }
//   if (mainitem?.Customer?.CurrAddState) {
//     currAddress += mainitem?.Customer?.CurrAddState + ", ";
//   }
//   if (mainitem?.Customer?.CurrAddPincode) {
//     currAddress += mainitem?.Customer?.CurrAddPincode + " ";
//   }

//   const billingDetails = [
//     `NAME                      :   FR - 53`,
//     `Invoice No               : `,
//   ];

//   let startY = boxTopMargin + 8;
//   billingDetails.forEach((detail) => {
//     doc.text(detail, boxPadding + 2, startY);
//     startY += 6;
//   });

//   // Second column data
//   const secondColumn = [
//     { label: "Date               ", value: "" },
//     { label: "Lot NO        ", value: "" },
//   ];

//   // Define second column starting position
//   const secondColumnStartX = boxPadding + 100; // Adjust as needed
//   let secondColumnStartY = boxTopMargin + 8; // Align with first column

//   // Print second column data
//   secondColumn.forEach(({ label, value }) => {
//     doc.text(`${label}: ${value}`, secondColumnStartX + 50, secondColumnStartY);
//     secondColumnStartY += 6; // Move to the next line
//   });

//   const rowHeight = 10; // Height per item row
//   let tableStartY = startY; // Start of the table

//   const columnWidths = {
//     "Sr No": 13.18,
//     SKU: 20.18,
//     Testing: 23,
//     "G wt": 28.18,
//     "St wt": 28.18,
//     "S Pcs": 28.18,
//     "Tag Wt": 28.18,
//     Pair: 35,
//   };

//   const columnArray = [
//     "Sr No",
//     "SKU",
//     "Testing",
//     "G wt",
//     "St wt",
//     "S Pcs",
//     "Tag Wt",
//     "Pair",
//   ];

//   // Function to render table headers
//   function renderHeaders(currentY) {
//     let startX = boxPadding; // Starting X position for table
//     columnArray.forEach((col) => {
//       doc.text(col, startX + 2, currentY + 2);
//       startX += columnWidths[col];
//     });

//     // Draw vertical lines for headers
//     startX = boxPadding;
//     columnArray.forEach((col, index) => {
//       // if(index == columnArray.length - 1){
//       //   return
//       // }
//       doc.line(startX, currentY - 4, startX, currentY + rowHeight + 3); // Vertical line
//       startX += columnWidths[col];
//     });

//     // Ensure the last vertical line extends fully
//     doc.line(startX, currentY + 2, startX, currentY + rowHeight + 3);
//   }

//   // Ensure headers on the first page
//   renderHeaders(tableStartY);

//   tableStartY += 7; // Adjust for the first header row

//   doc.line(5, 68.5, 205, 68.5);
//   doc.line(5, 76.5, 205, 76.5);
//   // Draw table and handle borders
//   let rowStartY = tableStartY;

//   let tableHeightUsed = 0;
//   doc.setFont("Helvetica", "Normal");
//   doc.setFontSize(8);
//   items?.forEach((item, index) => {
//     if (rowStartY + rowHeight > pageHeight - 5) {
//       const contentHeight = rowStartY - tableStartY;

//       tableHeightUsed += rowStartY - tableStartY;

//       doc.addPage(); // Add a new page
//       rowStartY = 3; // Reset Y position for the new page
//       tableStartY = rowStartY; // Update table start Y for the new page

//       // Draw a new table border for the new page
//       renderHeaders(rowStartY - 2);
//       rowStartY += 7; // Position after headers
//       // doc.line(5, 10, 205, 10); //horizontal line after table headers
//     }

//     let startX = boxPadding + 2; // Reset startX for each new row
//     const itemData = [
//       item?.ProductName || "",
//       item?.HSNCode || "",
//       item?.Purity || "",
//       item?.Quantity || "",
//       (+(item?.GrossWt || 0))?.toFixed(3),
//       (+(item?.TotalStoneWeight || 0))?.toFixed(3),
//       (+(item?.NetWt || 0))?.toFixed(3),
//       (+(item?.StoneAmount || 0))?.toFixed(3),
//       // (+(item?.MetalRate || 0))?.toFixed(3),
//       // (+(item?.MakingPerGram || 0))?.toFixed(3),
//       // (+(item?.HallmarkAmount || 0))?.toFixed(3),
//       // (+(item?.MRP || item?.TotalItemAmount || 0))?.toFixed(3),
//     ];

//     itemData.forEach((data, colIndex) => {
//       doc.text(`${data}`, startX, rowStartY + 8);
//       startX += columnWidths[columnArray[colIndex]];
//     });

//     doc.setFont("Helvetica", "Normal");
//     doc.setFontSize(8);
//     // Draw vertical lines for table rows
//     startX = boxPadding;
//     columnArray.forEach((col, colIndex) => {
//       doc.line(startX, rowStartY, startX, rowStartY + rowHeight + 10); // Vertical line for each column
//       startX += columnWidths[col];
//       if (colIndex === columnArray.length - 1) {
//         doc.line(
//           startX - 4,
//           rowStartY - 11,
//           startX - 4,
//           rowStartY + rowHeight + 10
//         ); // Last vertical line
//       }
//     });

//     rowStartY += rowHeight; // Move to the next row
//   });

//   // Store the final table height used on the last page
//   tableHeightUsed += rowStartY - tableStartY;

//   // Additional contents (for example, terms, conditions, signatures, etc.)
//   let contentStartY = rowStartY + 10; // Start below the table

//   // Draw final table border for the last page
//   let finalContentHeight = rowStartY - tableStartY;

//   if (contentStartY + 20 > pageHeight) {
//     // Draw final table border for the last page
//     finalContentHeight = rowStartY - tableStartY + 4;
//   }

//   if (contentStartY + 20 > pageHeight) {
//     doc.addPage(); // Add a new page
//     contentStartY = 10; // Reset Y on new page
//   }

//   if (rowStartY <= pageHeight - 5) {
//     doc.line(5, rowStartY, 205, rowStartY);
//   }

//   function checkAndAddPage(currentY, sectionHeight) {
//     if (currentY + sectionHeight > pageHeight - 20) {
//       // Adjust to prevent cutoff
//       doc.addPage();
//       return 10; // Reset Y position for new page
//     }
//     return currentY;
//   }

//   const cashSectionX = 5; // Starting X position for the cash section
//   let summaryStartY = rowStartY; // Add spacing after the first table
//   summaryStartY = checkAndAddPage(summaryStartY, 80); // Ensure it fits in the page
//   let cashStartY = summaryStartY; // Place cash details below summary
//   cashStartY = checkAndAddPage(cashStartY, 20); // Ensure cash details fit
//   const cashCellWidth = 50; // Width of each column for the cash table

//   // Draw the "Cash" label cell
//   doc.setFontSize(8);
//   doc.setFont("helvetica", "normal");

//   const leftColumn = [
//     { label: "Gross Amount", value: `${totalgross.toFixed(3)}` },
//     { label: "CGST 1.5%", value: `${Number(cgst).toFixed(2)}` },
//     { label: "SGST 1.5%", value: `${Number(sgst).toFixed(2)}` },
//     { label: "IGST 3%", value: `${GSTNumber.toFixed(2)}` },
//     // { label: 'Courier', value: '' },
//     { label: "Purchase Amount (-)", value: `${UrdPurchaseAmt}` },
//     { label: "RO/Discount (-)", value: "" },
//     { label: "Net Amount", value: `${(totalgross + GSTNumber).toFixed(2)}` },
//   ];

//   console.log(adminLoggedIn);
//   // Dummy values for the right column
//   const rightColumnValues = [
//     `${mainitem?.TotalNetAmount}`,
//     `${
//       adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
//         ? Number(cgst).toFixed(2)
//         : ""
//     }`,
//     `${
//       adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
//         ? Number(sgst).toFixed(2)
//         : ""
//     }`,
//     `${
//       adminLoggedIn?.State != mainitem?.Customer?.CurrAddState
//         ? (+(GST || 0)).toFixed(2)
//         : ""
//     }`,
//     // `${(+(mainitem?.CourierCharge || 0))?.toFixed(3)}`,
//     `${(
//       +(mainitem?.TotalNetAmount || 0) +
//       +(mainitem?.GST || 0) +
//       +(mainitem?.TDS || 0) +
//       +(mainitem?.CourierCharge || 0)
//     )?.toFixed(3)}`,
//     `${mainitem?.Offer || ""}`,
//     `${(
//       +(mainitem?.TotalNetAmount || 0) +
//       +(mainitem?.GST || 0) +
//       +(mainitem?.TDS || 0) +
//       +(mainitem?.CourierCharge || 0) -
//       +(mainitem?.Offer || 0)
//     )?.toFixed(3)}`,
//   ];

//   // Set table starting position and dimensions
//   const startX4 = 135; // Starting X position for the table
//   const startY4 = 130; // Starting Y position for the table
//   const tableWidth4 = 70; // Table width
//   const tableHeight4 = 80; // Table height (adjust based on number of rows)
//   const cellHeight4 = 10; // Height for each cell row
//   const verticalLineX = startX4 + tableWidth4 / 2; // X position for the center vertical line

//   let ypos;

//   let newTableStartY = rowStartY + 10; // Ensure proper spacing below dynamic table
//   doc.setFont("helvetica", "normal");

//   let newTableRowStartY = newTableStartY - 10;

//   let cashStartY2 = newTableRowStartY + 25; // Move below the new table

//   let rtgsStartY = cashStartY2 + 12;

//   // Calculate total values
//   let totalGrossWt = items.reduce(
//     (sum, item) => sum + +(item?.GrossWt || 0),
//     0
//   );
//   let totalStoneWt = items.reduce(
//     (sum, item) => sum + +(item?.TotalStoneWeight || 0),
//     0
//   );
//   let totalStonePcs = items.reduce((sum, item) => sum + +(item?.S_Pcs || 0), 0);
//   let totalTagWt = items.reduce((sum, item) => sum + +(item?.NetWt || 0), 0);
//   let totalPair = items.reduce(
//     (sum, item) => sum + +(item?.StoneAmount || 0),
//     0
//   );

//   // Position the total row below the last item
//   let totalRowY = rowStartY;

//   // Ensure we don't run off the page
//   if (totalRowY + rowHeight > pageHeight - 5) {
//     doc.addPage();
//     totalRowY = 10;
//     renderHeaders(totalRowY - 2); // Re-render table headers
//     totalRowY += 7;
//   }

//   // **Draw the Total Row**
//   let startX = boxPadding + 2;
//   const totalData = [
//     "Total", // "Sr No" column
//     "", // SKU
//     "", // Testing
//     totalGrossWt.toFixed(3), // G wt
//     totalStoneWt.toFixed(3), // St wt
//     totalStonePcs.toFixed(3), // S Pcs
//     totalTagWt.toFixed(3), // Tag Wt
//     totalPair.toFixed(3), // Pair
//   ];

//   // **Draw the rectangle covering the total row**
//   doc.rect(5, totalRowY, 200, rowHeight); // X, Y, Width, Height

//   // Print Total Row Data
//   totalData.forEach((data, colIndex) => {
//     doc.setFont("Helvetica", "Bold");
//     doc.text(`${data}`, startX, totalRowY + 8);
//     startX += columnWidths[columnArray[colIndex]];
//   });

//   // Draw bottom border for total row
//   doc.line(5, totalRowY + rowHeight, 205, totalRowY + rowHeight);

//   const pdfData = doc.output("datauristring");
//   const newWindow = window.open();
//   newWindow.document.write(
//     `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
//   );
// }


// export default generatePurchaseInvoice;
